module.exports = require('../../modules/_wks-ext').f('species');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/species.js
// module id = 541
// module chunks = 158